import pharmacy from 'services/pharmacy';
import { useDispatch } from 'react-redux';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { browserHistory } from 'App';
import environmentVariable from '../env/env.json';
import * as Types from "../helpers/types";

const setCheckoutPlatformVersion = ({features: { new_checkout_platform_enabled : flag}}) => {
  // If flag is true, use new checkout platform
  if (flag) {
    window.CHECKOUT_PUBLIC_KEY = environmentVariable.checkout_public_key;
  } else {
    window.CHECKOUT_PUBLIC_KEY = environmentVariable.checkout_public_key_old;
  }
}

export default () => {
  const dispatch = useDispatch();
  const getConfig = async () => {
    try {
      dispatch({ type: Types.CONFIG_LOADING });
      const response = await pharmacy.get(`/config`);
      dispatch({ type: Types.CONFIG_SUCCESS, payload: response.data });
      await setCheckoutPlatformVersion(response.data);
      return response.data;
    } catch (e) {
      dispatch({ type: Types.CONFIG_ERROR, payload: e });
      if (e.response && e.response.data.readable_error_message) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: e.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
        browserHistory.push('/pharmacy/error');
      }
      throw e;
    }
  };

  return [getConfig];
};
